import { useState } from "react";
import "./OwStarRating.scss";

type Props = {
    name: string;
    fn: (e: any) => void;
};

const OwStarRating = (props: Props) => {
    const [starNo, setStarNo] = useState<number | null>(null);

    const highlightStar = (starNo: number) => {
        for (let i = 1; i <= starNo; ++i) {
            const elem = document.getElementById(`star-${i}-${props.name}`);
            if (elem) {
                // let className = elem.className;

                elem.className = `fas fa-star text-warning ${i < 5 ? "me-2" : ""}`;
            }
        }

        if (starNo) {
            // clear the stars after the starNo ?
            for (let i = 5; i > starNo; --i) {
                const elem = document.getElementById(`star-${i}-${props.name}`);
                if (elem) {
                    // let className = elem.className;

                    elem.className = `far fa-star ${i < 5 ? "me-2" : ""}`;
                }
            }
        }
    };

    const clearHighlight = (starNo: number) => {
        if (starNo) {
            return;
        }

        for (let i = 5; i >= starNo; --i) {
            const elem = document.getElementById(`star-${i}-${props.name}`);
            if (elem) {
                // let className = elem.className;

                elem.className = `far fa-star ${i < 5 ? "me-2" : ""}`;
            }
        }
    };

    const setStarFn = (starNo: number) => {
        setStarNo(starNo);

        const e: any = {
            target: {
                value: starNo,
                name: props.name,
            },
        };

        props.fn(e);
    };

    const clearAllStars = () => {
        if (starNo) {
            return;
        }

        for (let i = 1; i <= 5; ++i) {
            const elem = document.getElementById(`star-${i}-${props.name}`);
            if (elem) {
                // let className = elem.className;

                elem.className = `far fa-star ${i < 5 ? "me-2" : ""}`;
            }
        }
    };

    const starNos = [1, 2, 3, 4, 5];

    return (
        <div
            className="OwStarRating d-flex"
            onMouseOut={() => {
                clearAllStars();
            }}>
            {starNos.map((starNo) => {
                return (
                    <i
                        key={starNo}
                        data-testid={`star-${starNo}-${props.name}`}
                        role={"star"}
                        className={"far fa-star me-2"}
                        id={`star-${starNo}-${props.name}`}
                        onMouseOver={() => {
                            highlightStar(starNo);
                        }}
                        onMouseOut={() => {
                            clearHighlight(starNo);
                        }}
                        onClick={() => {
                            setStarFn(starNo);
                        }}
                    />
                );
            })}
        </div>
    );
};

export default OwStarRating;
